<template>
  <v-checkbox :input-value="enabled" :ripple="false" @change="$emit('update:enabled', $event)">
    <template v-slot:label>
      {{ $t("components.partner.TicketCreateCheckbox.prefix") }}
      <span class="inline-field" @click.stop @mousedown.stop>
        <v-text-field
          type="date"
          v-model="dateModel"
          :min="todayISO"
          :readonly="disabled"
          dense
          hide-details
          class="date-input"
          @click.stop
          @keydown.stop
        />
      </span>
      {{ $t("components.partner.TicketCreateCheckbox.suffix") }}
    </template>
  </v-checkbox>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class TicketCreateCheckbox extends Vue {
  @Prop({ required: true }) value!: string | null;
  @Prop({ default: false }) enabled!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  get todayISO() {
    const d = new Date();
    return d.toISOString().slice(0, 10);
  }
  get inputStyle() {
    return { width: "135px", display: "inline-block", margin: "0 2px" };
  }
  get dateModel(): string {
    return this.value ? this.value.slice(0, 10) : "";
  }
  set dateModel(val: string) {
    const norm = val ? val.slice(0, 10) : null;
    this.$emit("input", norm);
    this.$emit("update:value", norm);
    if (norm && !this.enabled) this.$emit("update:enabled", true);
  }
}
</script>
<style scoped>
.date-input ::v-deep input[type="date"] {
  direction: rtl;
  text-align: left;
}
.date-input {
  width: 135px;
  display: inline-block;
  margin: 0 2px;
}
.date-input ::v-deep input {
  padding-left: 8px;
  padding-right: 8px;
}
.date-input ::v-deep input[type="date"] {
  text-align: right !important;
}
</style>
